import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import AuthModal from './AuthModal';

const tabs = [
  { id: 'home',  label: 'Головна' },
  { id: 'menu',  label: 'Меню' },
  { id: 'lanch', label: 'Ланч' },
  { id: 'bar',   label: 'Бар' },
];

const icons = {
  home: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M3 9.5L10 3l7 6.5V17a1 1 0 01-1 1H4a1 1 0 01-1-1V9.5z"
        stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round"/>
      <rect x="7.5" y="11" width="5" height="7" rx="0.5" stroke="currentColor" strokeWidth="1.6"/>
    </svg>
  ),
  menu: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <rect x="3" y="4" width="6" height="6" rx="1.5" fill="currentColor" opacity="0.9"/>
      <rect x="11" y="4" width="6" height="6" rx="1.5" fill="currentColor" opacity="0.9"/>
      <rect x="3" y="12" width="6" height="6" rx="1.5" fill="currentColor" opacity="0.9"/>
      <rect x="11" y="12" width="6" height="6" rx="1.5" fill="currentColor" opacity="0.9"/>
    </svg>
  ),
  lanch: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <line x1="4" y1="6"  x2="16" y2="6"  stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
      <line x1="4" y1="10" x2="13" y2="10" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
      <line x1="4" y1="14" x2="16" y2="14" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
    </svg>
  ),
  bar: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <circle cx="10" cy="10" r="6" stroke="currentColor" strokeWidth="1.8"/>
      <circle cx="10" cy="10" r="2.5" fill="currentColor" opacity="0.7"/>
    </svg>
  ),
};

export default function Sidebar({ activeTab, onTabChange }) {
  const { user, logout } = useAuth();
  const [showAuth, setShowAuth]     = useState(false);
  const [showMenu, setShowMenu]     = useState(false);

  const handleUserClick = () => {
    if (user) setShowMenu(m => !m);
    else setShowAuth(true);
  };

  return (
    <>
      <aside style={{
        width: 72, background: '#0d0d0b',
        display: 'flex', flexDirection: 'column',
        alignItems: 'center', padding: '20px 0', gap: 4, flexShrink: 0,
      }}>
        
        {/* Відступ зверху, щоб кнопки навігації не прилипали до краю (замість букви R) */}
        <div style={{ height: 20 }} />

        {/* Nav */}
        {tabs.map(tab => {
          const active = activeTab === tab.id;
          return (
            <button key={tab.id} className="sidebar-btn"
              onClick={() => onTabChange(tab.id)}
              style={{
                width: 52, minHeight: 52, borderRadius: 12, border: 'none',
                background: active ? 'rgba(255,255,255,0.13)' : 'transparent',
                color: active ? '#fff' : 'rgba(255,255,255,0.38)',
                display: 'flex', flexDirection: 'column',
                alignItems: 'center', justifyContent: 'center', gap: 5,
                cursor: 'pointer', transition: 'background 0.2s'
              }}
              onMouseEnter={e => { if (!active) e.currentTarget.style.background = 'rgba(255,255,255,0.07)'; }}
              onMouseLeave={e => { if (!active) e.currentTarget.style.background = 'transparent'; }}
            >
              {icons[tab.id]}
              <span style={{ fontSize: 9, letterSpacing: '0.6px', lineHeight: 1 }}>{tab.label}</span>
            </button>
          );
        })}

        <div style={{ flex: 1 }} />

        {/* User button (ЗАЛИШИЛИ) */}
        <div style={{ position: 'relative' }}>
          <button
            onClick={handleUserClick}
            title={user ? user.name : 'Увійти'}
            style={{
              width: 40, height: 40, borderRadius: 10,
              background: user ? '#2d5e40' : 'rgba(255,255,255,0.1)',
              border: 'none', cursor: 'pointer',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: user ? 14 : 18, color: '#fff',
              transition: 'background 0.15s, transform 0.12s',
              marginBottom: 8,
            }}
            onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.08)'}
            onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
          >
            {user ? user.name[0].toUpperCase() : '👤'}
          </button>

          {/* User dropdown (ЗАЛИШИЛИ) */}
          {showMenu && user && (
            <div style={{
              position: 'absolute', bottom: 48, left: 48,
              background: '#fff', borderRadius: 12, border: '1px solid #ddd5c8',
              boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
              padding: '8px', zIndex: 100, minWidth: 180,
            }}>
              <div style={{ padding: '8px 12px', borderBottom: '1px solid #ddd5c8', marginBottom: 4 }}>
                <div style={{ fontSize: 13, fontWeight: 500, color: '#0d0d0b' }}>{user.name}</div>
                <div style={{ fontSize: 11, color: '#6b6560', fontWeight: 300 }}>{user.email}</div>
              </div>

              {user.role === 'admin' && (
                <button
                  onClick={() => { window.open('https://admin.okolitsya-lentochka.com.ua', '_blank'); setShowMenu(false); }}
                  style={{
                    display: 'flex', alignItems: 'center', gap: 8,
                    width: '100%', padding: '8px 12px', border: 'none',
                    background: 'transparent', fontSize: 13, cursor: 'pointer',
                    borderRadius: 8, color: '#2d5e40', fontWeight: 500,
                    transition: 'background 0.12s',
                  }}
                  onMouseEnter={e => e.currentTarget.style.background = '#edf5ef'}
                  onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                >
                  ⚙️ Панель керування
                </button>
              )}

              <button
                onClick={() => { logout(); setShowMenu(false); }}
                style={{
                  display: 'flex', alignItems: 'center', gap: 8,
                  width: '100%', padding: '8px 12px', border: 'none',
                  background: 'transparent', fontSize: 13, cursor: 'pointer',
                  borderRadius: 8, color: '#c0392b',
                  transition: 'background 0.12s',
                }}
                onMouseEnter={e => e.currentTarget.style.background = '#fdecea'}
                onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
              >
                🚪 Вийти
              </button>
            </div>
          )}
        </div>
      </aside>

      {showAuth && <AuthModal onClose={() => setShowAuth(false)} />}
    </>
  );
}
